import React from 'react';

import './OverlayMenu.css';

const OverlayMenu = props => (
  <div className="overlay" onClick={props.click}/>
);

export default OverlayMenu;